import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { Link } from "react-router-dom";
export class Footer extends Component {
    state = { 
		categories: []
    };
    componentDidMount() {     
		this.context.state.getEducationCategories();
	}

    render() {
        return (
            <section className="footer lander-footer mt-5">
                <div className="container">
				    <div className="sub-container mx-auto">
				        <div className="d-flex justify-content-between">
					        <ul className="mb-md-0 mb-4 text-md-left text-center">
					    	    <li>
					    		    <h4><a className="py-3 d-block" target="_blank"  href="/education">Education</a></h4>
					    		</li>
					    	    {
									
									// map over the array here and display your list items
									(this.context.state.eduCategories).map(function(item, key) {
									return (
										<li key={key}>
											<a className="py-2 d-block" target="_blank"  href={`/education/${item.slug}`}>{item.title}</a>
										</li>
									)
									})
									
								}							
					    	</ul>
					    	<ul className="mb-md-0 mb-4 text-md-left text-center">
					    	    <li>
					    		    <h4><a className="py-3 d-block" target="_blank"  href="/jobs">Jobs</a></h4>
					    		</li>					    	    
                                <li>
					    		    <a className="py-2 d-block" target="_blank"  href="/jobs/industries">Industries</a>
					    		</li>
                                <li>
					    		    <a className="py-2 d-block" target="_blank" href="/jobs/hire-writers">Hire Writers</a>
					    		</li>
                            </ul>
					    	<ul className="mb-md-0 mb-4 text-md-left text-center">
					    	    <li>
					    		    <h4><a className="py-3 d-block" target="_blank"  href="/library/article">Library</a></h4>
					    		</li>
					    	    <li>
					    		    <a className="py-2 d-block" target="_blank" href="/library/articles">Articles</a>
					    		</li>
                                <li>
					    		    <a className="py-2 d-block" target="_blank" href="/library/guides">Guides</a>
					    		</li>
                                <li>
					    		    <a className="py-2 d-block" target="_blank" href="/library/resources">Resources</a>
					    		</li>
                            </ul>
					    	<ul className="mb-md-0 mb-4 text-md-left text-center">
					    	    <li>
					    		    <h4><a className="py-3 d-block" target="_blank" href="/tools/portfolios">Tools</a></h4>
					    		</li>
					    	    <li>
					    		    <a className="py-2 d-block" target="_blank" href="/tools/portfolios">Portfolios</a>
					    		</li>
                                <li>
					    		    <a className="py-2 d-block" target="_blank" href="/tools/submissions">Submissions</a>
					    		</li>
                            </ul>
					    	<ul className="mb-md-0 mb-4 text-md-left text-center">
					    	    <li>
					    		    <h4><span className="py-3 d-block" onClick={(e) => {e.preventDefault();}}>Follow</span></h4>
					    		</li>
					    		<li>
					    		    <ul className="d-flex justify-content-md-start justify-content-center">
					    	            <li>
					    		            <a className="pt-2 pr-3 d-block" target="_blank" href="https://www.twitter.com/prowriterhq"><i className="fab fa-twitter"></i></a>
					    		        </li>
                                        <li>
					    		            <a className="pt-2 px-3 d-block" target="_blank" href="https://www.facebook.com/prowriterhq"><i className="fab fa-facebook-f"></i></a>
					    		        </li>
                                        <li>
					    		            <a className="pt-2 px-3 d-block" target="_blank" href="https://www.instagram.com/prowriterhq"><i className="fab fa-instagram"></i></a>
					    		        </li>
					    		        <li>
					    		            <a className="pt-2 pl-3 d-block" target="_blank" href="https://www.pinterest.com/prowriterhq"><i className="fab fa-pinterest-p"></i></a>
					    		        </li>
					    			</ul>	
					    		</li>	
                            </ul>
					    </div>
					</div>	
				</div>
            </section>
        );
    }
}

Footer.contextType = AppContext;
export default Footer;



// WEBPACK FOOTER //
// ./src/components/general/include/Footer.js